import React, { useState, useEffect, useRef } from "react";
import FeatherIcon from "feather-icons-react"; // Assuming you have installed the feather-icons-react package
import { useDispatch, useSelector } from "react-redux";
import { getPayment } from "../../Actions/paymentAction";
import { Loader } from "feather-icons-react/build/IconComponents";
const BillTable = () => {
  const [data,setData]=useState([]);
  const dispatch = useDispatch();
  const storePreviewData = useSelector((state) => state.saveProfilePreview);
  const storePaymentData = useSelector((state) => state.payment);
  
  const { saveProfilePreviewData, loadingData, errorData } = storePreviewData;
  const { paymentData, loading, error } = storePaymentData;
    useEffect(() => {
      const fetchData = async () => {
  let InitialCaseId=localStorage.getItem('InitialCaseId');
          let record={};
          record.initial_case_id=[InitialCaseId];
      dispatch(getPayment(record));
  };
   fetchData();
}, []);


  useEffect(() => {
    if (typeof paymentData?.data !== "undefined" && paymentData?.data !== null) {
      setData(paymentData.data.paymentData);
    }
  }, [paymentData, storePaymentData]);

 
  return (
    <div className="table-responsive">
      <table className="table  table-bordered">
        <thead>
          <tr style={{ background: "#E4E7EC" }}>
            <th>Sr.no</th>
            <th>Name</th>
            <th>Package</th>
            <th>Amount</th>
            <th>GST</th>
            <th>Total Amt.</th>
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          { data && data.map((item,id) => (
            <tr key={id}>
              <td>{id+1}</td>
              <td>{item.candidate_name}</td>
              <td>{item.package_name}</td>
              {/* <td className="badge badge-pill badge-primary">{item.checks}</td> */}
              <td>{item.amount/1.18}</td>
              <td>{(item.amount*0.18)/1.18}</td>
              <td>{item.amount}</td>
              {/* <td>
                <FeatherIcon icon="trash-2" />
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
      <div
        style={{
          /* Text */
          width: "223px",
          height: "20px",
          fontFamily: "Inter",
          fontStyle: "normal",
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "20px",
          /* identical to box height, or 111% */
          /* Primary/800 */
          color: "#1849A9",
        }}
        className="d-flex justify-content-end align-items-center"
      >
        Total Amount: ₹ {paymentData?.data?.amountToPay}
      </div>
    </div>
  );
};

export default BillTable;
